import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu } from "../../context/MenuContext";
import { useContext, useEffect, useRef, useState } from "react";
import Cookie from "cookie-universal";
import { useNavigate, Link, useLocation } from "react-router-dom";
import useTheme from "../../hooks/useTheme";

export default function TopBar() {
  const { setIsOpen } = useContext(Menu);
  const cookie       = Cookie();
  const navigate     = useNavigate();
  const location     = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [dropOpen, setDropOpen] = useState(false);
  const dropRef = useRef(null);
  const { theme, toggle } = useTheme();

  const userName = cookie.get("user_name") || "المشرف";
  const role     = cookie.get("role") || "admin";
  const initials = userName.charAt(0).toUpperCase();

  /* close dropdown on outside click */
  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* close dropdown on route change */
  useEffect(() => setDropOpen(false), [location.pathname]);

  useEffect(() => {
    const el = document.querySelector(".dashboard-content") || window;
    const onScroll = () => setScrolled((el.scrollTop ?? el.scrollY) > 10);
    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = () => {
    const opts = { path: "/" };
    cookie.remove("rasheed", opts);
    cookie.remove("user_name", opts);
    cookie.remove("role", opts);
    cookie.remove("refresh_token", opts);
    navigate("/");
  };

  const isSettings = location.pathname.includes("/dashboard/settings");

  return (
    <div className={`top-bar${scrolled ? " top-bar-glass" : ""}`}>
      <div className="top-bar-inner">

        {/* Left: sidebar toggle + brand */}
        <div className="top-bar-left">
          <button className="top-bar-toggle" onClick={() => setIsOpen((p) => !p)} title="القائمة">
            <FontAwesomeIcon icon={faBars} />
          </button>
          <Link to="/" className="top-bar-brand">
            <div className="top-bar-brand-icon">
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm0 12.5L3 11.09V17c0 2.76 4.03 5 9 5s9-2.24 9-5v-5.91L12 15.5z" />
              </svg>
            </div>
            <span className="top-bar-logo">أكادمية التعليم</span>
          </Link>
        </div>

        {/* Right: theme toggle + avatar dropdown */}
        <div className="top-bar-right">

          {/* Dark / Light toggle */}
          <button
            className="topbar-theme-btn"
            onClick={toggle}
            title={theme === "dark" ? "الوضع الفاتح" : "الوضع الداكن"}
          >
            {theme === "dark" ? (
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 7a5 5 0 1 0 0 10A5 5 0 0 0 12 7zM2 13h2a1 1 0 0 0 0-2H2a1 1 0 0 0 0 2zm18 0h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2zM11 2v2a1 1 0 0 0 2 0V2a1 1 0 0 0-2 0zm0 18v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-2 0zM5.99 4.58a1 1 0 0 0-1.41 1.41l1.06 1.06a1 1 0 1 0 1.41-1.41L5.99 4.58zm12.37 12.37a1 1 0 0 0-1.41 1.41l1.06 1.06a1 1 0 0 0 1.41-1.41l-1.06-1.06zm1.06-10.96a1 1 0 0 0-1.41-1.41l-1.06 1.06a1 1 0 0 0 1.41 1.41l1.06-1.06zM7.05 18.36a1 1 0 0 0-1.41-1.41l-1.06 1.06a1 1 0 0 0 1.41 1.41l1.06-1.06z"/>
              </svg>
            ) : (
              <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 0 1-4.4 2.26 5.403 5.403 0 0 1-5.4-5.4c0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/>
              </svg>
            )}
          </button>

          {/* Avatar + dropdown */}
          <div className="topbar-avatar-wrap" ref={dropRef}>
            <button
              className={`topbar-avatar-btn${dropOpen ? " open" : ""}`}
              onClick={() => setDropOpen((p) => !p)}
              title={userName}
            >
              {initials}
            </button>

            {dropOpen && (
              <div className="topbar-dropdown">
                {/* User info */}
                <div className="td-user-info">
                  <div className="td-avatar-lg">{initials}</div>
                  <div className="td-user-text">
                    <span className="td-user-name">{userName}</span>
                    <span className={`td-user-role${role === "superadmin" ? " super" : ""}`}>
                      {role === "superadmin" ? "سوبر أدمن" : "أدمن"}
                    </span>
                  </div>
                </div>

                <div className="td-divider" />

                {/* Settings */}
                <button
                  className={`td-item${isSettings ? " td-item-active" : ""}`}
                  onClick={() => navigate("/dashboard/settings")}
                >
                  <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.14 12.94c.04-.3.06-.61.06-.94s-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.49.49 0 0 0-.59-.22l-2.39.96a6.96 6.96 0 0 0-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.48.48 0 0 0-.59.22L2.74 8.87a.47.47 0 0 0 .12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.47.47 0 0 0-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
                  </svg>
                  الإعدادات
                </button>

                <div className="td-divider" />

                {/* Logout */}
                <button className="td-item td-item-danger" onClick={handleLogout}>
                  <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
                  </svg>
                  تسجيل الخروج
                </button>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
